// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld/base/core';
import './formComponent';

/**
 * @class  Dropdown
 * @param  {array<string>} options.options Options to add to the select box
 * @param  {string} options.selected Selected item identifier
 * @param  {function} options.onChange onChange handler
 
 * @example
 * new myw.Dropdown(options:['On', 'Off'], selected: 'On'})
 *
 * @extends {FormComponent}
 **/
myw.Dropdown = myw.FormComponent.extend({
    tagName: 'select',
    className: 'ui-select',
    blackListParams: ['onChange'],

    events: {
        change: '_onChange'
    },

    initialize(options) {
        myw.FormComponent.prototype.initialize.call(this, options);
        //Populate the options
        if (this.options.placeholder && this.options.selected == null) {
            this.$el.append(`<option value="" selected>${this.options.placeholder}</option>`);
        }

        _.each(this.options.options, option => {
            if (typeof option != 'object') {
                this.$el.append(
                    `<option ${
                        option == this.options.selected ? 'selected' : ''
                    }>${option.toString()}</option>`
                );
                return;
            }
            this.$el.append(
                `<option value="${option.id}" ${
                    option.id == this.options.selected ? 'selected' : ''
                }>${option.label}</option>`
            );
        });

        myw.FormComponent.prototype.render.call(this, options);

        return this;
    },

    _onChange() {
        const options = this.options;
        if (options.onChange) {
            options.onChange.call({}, this);
        }
    }
});

myw.View.prototype.componentMapping['dropdown'] = myw.Dropdown;

export default myw.Dropdown;
